import React, { useState } from "react";

import Carousel from "react-elastic-carousel";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Carousel as ReactCarousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// Mui
import { withStyles, useTheme } from "@mui/styles";
import { Grid, Typography } from "@mui/material";

// App
import theme from "app/theme";

const Home = ({ classes }) => {
  return (
    <Grid
      style={{ height: "100vh", width: "100vw", backgroundColor: "#041407" }}
    >
      <Grid
        style={{
          width: "90%",
          height: "100vh",
          maxWidth: "650px",
          margin: "0 auto",
          paddingBottom: "50px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="./PastorsMastersLogo.svg"
          alt="Pastors Masters logo"
          style={{ width: "250px", margin: "0 auto 50px" }}
        />
        <Typography
          variant="h5"
          style={{ color: "white", textAlign: "center", marginBottom: "20px" }}
        >
          After many years, the Pastors Masters Golf Tournament Fundraiser has
          completed its run. We're incredibly proud of the funds raised and the
          lives touched along the way.
        </Typography>
        <Typography style={{ color: "white", textAlign: "center" }}>
          Stay tuned for future fundraising events supporting new causes close
          to our hearts.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Home;
